import { render, staticRenderFns } from "./StartPage.vue?vue&type=template&id=bbc7d4e6&scoped=true"
import script from "./StartPage.vue?vue&type=script&lang=js"
export * from "./StartPage.vue?vue&type=script&lang=js"
import style0 from "./StartPage.vue?vue&type=style&index=0&id=bbc7d4e6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bbc7d4e6",
  null
  
)

export default component.exports